import React, { useState, useContext, useEffect } from 'react'
import { useDropzone } from 'react-dropzone'

import FormControlLabel from '@material-ui/core/FormControlLabel'
import Grow from '@material-ui/core/Grow'
import Checkbox from '@material-ui/core/Checkbox'
import CircularProgress from '@material-ui/core/CircularProgress'
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep'
import Button from '@material-ui/core/Button'
import Alert from '@material-ui/lab/Alert'
import IconButton from '@material-ui/core/IconButton'
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile'
import Tooltip from '@material-ui/core/Tooltip'
import Modal from '@material-ui/core/Modal'
import Slider from '@material-ui/core/Slider'
import { withStyles, makeStyles } from '@material-ui/core/styles'

import CloseIcon from '@material-ui/icons/Close'
import FolderIcon from '@material-ui/icons/Folder'
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord'
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined'
import CreateNewFolderIcon from '@material-ui/icons/CreateNewFolder'
import DeleteIcon from '@material-ui/icons/Delete'
import AddIcon from '@material-ui/icons/Add'
import PublishIcon from '@material-ui/icons/Publish'
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined'
import VisibilityOffOutlinedIcon from '@material-ui/icons/VisibilityOffOutlined'
import SettingsIcon from '@material-ui/icons/Settings'
import ShowChartIcon from '@material-ui/icons/ShowChart'
import ListAltIcon from '@material-ui/icons/ListAlt'
import SearchIcon from '@material-ui/icons/Search'
import SaveIcon from '@material-ui/icons/Save'

import { CompactPicker } from 'react-color'

import polygonLogo from '../../../../../assets/shape.png'

import './kml.css'

const converter = require('@tmcw/togeojson')
const DOMParser = require('xmldom').DOMParser

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: 'white',
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;',
    borderLeft: '3px solid #a65e44',
    // fontSize: 11,
  },
}))(Tooltip)

const useStyles = makeStyles((theme) => ({
  loading: {
    color: '#a65e44',
    width: '30px !important',
    height: '30px !important',
    alignSelf: 'center',
    margin: 'auto',
    marginTop: '10px',
  },
  root: {
    color: 'rgba(166, 94, 68, 1) !important',
  },
  kmlDel: {
    color: '#bf0000',
  },
  modalBtn: {
    backgroundColor: '#a65e44',
    boxShadow: 'none',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#804631',
      borderColor: '#804631',
      boxShadow: 'none',
    },
  },
  slider: {
    color: '#c1c1c1',
    width: '50px',
    marginLeft: '13px',
    padding: '7px 0',
  },
}))

function KML(props) {
  const { acceptedFiles, getRootProps, open, getInputProps, inputRef } = useDropzone({
    noClick: true,
    accept: {
      'application/*': ['.kml'],
    },
    maxFiles: 5,
    maxSize: 41943040,
    onDrop: (files) => onDrop(files),
    onDropRejected: (file) => onDropRejected(file),
  })

  const classes = useStyles()

  const [fileCheck, setFileCheck] = useState([])
  const [file, setFile] = useState([])
  const [loading, setLoading] = useState(false)
  const [pointer, setPointer] = useState('all')

  const [alerta, setAlerta] = useState('0')
  const [alertLbl, setAlertLbl] = useState('')
  const [alertText, setAlertText] = useState([])
  const [addBtn, setAddBtn] = useState({ events: 'none', opacity: '0' })
  const [fileBtn, setFileBtn] = useState({ events: 'auto', filter: 'grayscale(0%)' })
  const [KML, setKML] = useState('270px')

  const [openModal, setOpenModal] = useState(false)
  const [errorModal, setErrorModal] = useState(false)
  const [settingsModal, setSettingsModal] = useState(false)
  const [dzDisplay, setDZDisplay] = useState('block')

  const [colorPolygon, setColorPolygon] = useState({
    hsl: {
      h: 3.9344262295081966,
      s: 0.8206278026905827,
      l: 0.5627450980392157,
      a: 80,
    },
    hex: '#eb4034',
    rgb: {
      r: 235,
      g: 64,
      b: 52,
      a: 80,
    },
    hsv: {
      h: 3.9344262295081966,
      s: 0.778723404255319,
      v: 0.9215686274509803,
      a: 80,
    },
    oldHue: 180,
    source: 'rgb',
  })

  const [colorLine, setColorLine] = useState({
    hsl: {
      h: 117.41176470588236,
      s: 1,
      l: 0.5,
      a: 1,
    },
    hex: '#0bff00',
    rgb: {
      r: 11,
      g: 255,
      b: 0,
      a: 1,
    },
    hsv: {
      h: 117.41176470588236,
      s: 1,
      v: 1,
      a: 1,
    },
    oldHue: 3.9344262295081966,
    source: 'rgb',
  })

  const [colorPoint, setColorPoint] = useState({
    hsl: {
      h: 208.94117647058826,
      s: 1,
      l: 0.5,
      a: 1,
    },
    hex: '#0084ff',
    rgb: {
      r: 0,
      g: 132,
      b: 255,
      a: 1,
    },
    hsv: {
      h: 208.94117647058826,
      s: 1,
      v: 1,
      a: 1,
    },
    oldHue: 3.9344262295081966,
    source: 'rgb',
  })

  const [list, setList] = useState([])
  const [listWidth, setListWidth] = useState({ width: '0px', border: '0px', margin: '0px' })
  const [fileName, setFileName] = useState('')

  const idb =
    window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB

  useEffect(() => {
    const request = idb.open('TestDB2', 1)
    request.onerror = (event) => {
      console.log(`Database error: ${event.target.errorCode}`)
    }

    request.onupgradeneeded = (event) => {
      const db = event.target.result

      const store = db.createObjectStore('tags', { keyPath: 'id' })
      store.createIndex('tag', 'tag', { unique: false })

      const storeLayer = db.createObjectStore('layers', { keyPath: 'id' })
      storeLayer.createIndex('layer', 'id', { unique: false })

      const storeFile = db.createObjectStore('fileList', { keyPath: 'name' })
      storeFile.createIndex('file', 'name', { unique: false })
    }

    getLayers()
  }, [])

  const kmlLayers = (data, id) => {
    const item = [...props.layerData]
    item.find((obj) => obj.id === id).data = data
    props.setLayerData(item)
  }

  const kmlLayersDB = (data, id) => {
    const item = [...props.layerData]
    item.find((obj) => obj.id === id).data = data
    item.find((obj) => obj.id === id).visible = false
    props.setLayerData(item)
  }

  const colorChange = (geometry, color, opacity) => {
    const item = [...props.layerData]
    item.map((obj) => {
      if (obj.geotype === 'kml') {
        obj.design.flag = [color.rgb.r, color.rgb.g, color.rgb.b, Math.random()]
        if (geometry === 'polygon') {
          const op = color
          opacity === undefined ? (op.rgb.a = colorPolygon.rgb.a) : (op.rgb.a = opacity * 2.55)
          setColorPolygon(op)
          //setColorPolygon(color)
          obj.design.polygonColor = [color.rgb.r, color.rgb.g, color.rgb.b, op.rgb.a]
        }
        if (geometry === 'point') {
          setColorPoint(color)
          obj.design.pointColor = [color.rgb.r, color.rgb.g, color.rgb.b]
        }
        if (geometry === 'line') {
          setColorLine(color)
          obj.design.lineColor = [color.rgb.r, color.rgb.g, color.rgb.b]
        }
      }
    })
    props.setLayerData(item)
  }

  const resetCheckBox = () => {
    var elems = document.getElementsByName('kml')

    for (var i = 0; i < elems.length; i++) {
      if (!elems[i].checked) elems[i].click()
    }
  }

  const CheckBox = (e, id) => {
    const item = [...props.layerData]
    item.find((obj) => obj.id === id).visible = e
    props.setLayerData(item)

    const checked = fileCheck
    checked.find((obj) => obj.id === id).checked = e
    setFileCheck(checked)
  }

  const onDrop = (data) => {
    if (file.length >= 5) {
      setAlertText([{ file: 'Error', errors: "You can't upload more than 5 files" }])
    } else {
      setDZDisplay('none')
      let test = file
      setFile(test.concat(data))
      setAlertText([])
      console.log(file)
    }
  }

  const errorMessages = (data) => {
    var string = ':'
    for (var i = 0; i < data.length; i++) {
      string += ' ' + data[i].code
    }
    return string
  }

  const onDropRejected = (data) => {
    if (file.length === 0) {
      setDZDisplay('block')
    }
    const errors = []
    data.map((obj) => {
      errors.push({ file: obj.file.name, errors: errorMessages(obj.errors) })
    })
    setAlertText(errors)
  }

  const fileMax = (files) => {
    const res = []
    for (let i = 0; i < files.length; i++) {
      res.push(files[i].size)
    }
    return Math.max(...res)
  }

  const upload = (e) => {
    if (file != undefined) {
      // setDZDisplay('block')
      resetCheckBox()
      setFileBtn({ events: 'none', filter: 'grayscale(100%)' })
      setAlerta('0')
      // setFilelbl('')
      const check = []
      for (let i = 0; i < file.length; i++) {
        check.push({ tag: file[i].name, id: 'kml-layer-' + i, checked: true })
        let reader = new FileReader()
        reader.readAsText(file[i])
        reader.onload = function () {
          const parsedKML = new DOMParser().parseFromString(reader.result)
          const geojson = converter.kml(parsedKML)
          kmlLayers(geojson, 'kml-layer-' + i)

          saveIndexDB({ tag: file[i].name, id: 'kml-layer-' + i }, geojson, 'kml-layer-' + i, file[i])

          if (geojson != undefined && file[i].size === fileMax(file)) {
            setLoading(false)
            setPointer('all')
            setAddBtn({ events: 'auto', opacity: '1' })
          }
        }
        reader.onerror = function () {
          console.log(reader.error)
          setErrorModal(true)
          setLoading(false)
        }
      }

      setFileCheck(check)
    } else if (file === undefined) {
      setAlerta('1')
      setAlertLbl('Select a kml file first')
      setPointer('all')
      setLoading(false)
    }
  }

  const uploadSingle = (e) => {
    const fileName = e.target.files[0].name
    const fileData = e.target.files[0]
    if (file.length > 4) {
      setAlerta('1')
      setAlertLbl('File limit reached')
      setTimeout(() => {
        setAlerta('0')
      }, 4000)
    }

    if (e.target.files[0].size >= 41943040) {
      setAlerta('1')
      setAlertLbl('File to large')
      setTimeout(() => {
        setAlerta('0')
      }, 4000)
    }
    if (file.length <= 4 && e.target.files[0].size < 41943040) {
      resetCheckBox()
      // ResetkmlLayers()
      setLoading(true)

      const array = file
      array.push(e.target.files[0])
      setFile(array)

      const check = fileCheck
      check.push({ tag: e.target.files[0].name, id: 'kml-layer-' + (file.length - 1), checked: true })
      setFileCheck(fileCheck)

      setAlerta('0')

      let reader = new FileReader()
      reader.readAsText(e.target.files[0])
      reader.onload = function () {
        const parsedKML = new DOMParser().parseFromString(reader.result)
        const geojson = converter.kml(parsedKML)
        kmlLayers(geojson, 'kml-layer-' + (file.length - 1))
        saveIndexDB(
          { tag: fileName, id: 'kml-layer-' + (file.length - 1) },
          geojson,
          'kml-layer-' + (file.length - 1),
          fileData,
        )

        if (geojson != undefined) setLoading(false)
      }
      reader.onerror = function () {
        console.log(reader.error)
        setErrorModal(true)
        setLoading(false)
      }
    } else if (file === undefined) {
      setAlerta('1')
      setLoading(false)
    }
  }

  const deleteKml = () => {
    if (file != undefined) {
      resetCheckBox()
      setFile([])
      setAddBtn({ events: 'none', opacity: '0' })
      setFileBtn({ events: 'auto', filter: 'grayscale(0%)' })
      setPointer('all')
      setFileCheck([])
      props.setLayerData([...props.layerData].filter((obj) => obj.geotype !== 'kml'))
      // setLayerDisplay(layerDisplay.filter(obj=>obj.id!=='kml-layer'))
      // setLayerDisplay(layerDisplay.filter(obj=>obj.geotype!=='kml'))
      // setFilelbl('')
      // kmlLayers(null)
      for (let i = 0; i < file.length; i++) {
        // setFilelbl('')
        kmlLayers(null, 'kml-layer-' + i)
      }
      setDZDisplay('block')
      // ResetkmlLayers()
      acceptedFiles.length = 0
      acceptedFiles.splice(0, acceptedFiles.length)
      deleteIDB()
    }
  }

  const deleteSingle = (id, tag) => {
    if (fileCheck.length <= 0) {
      resetCheckBox()
      let test = file.filter((obj) => obj.name !== tag)
      setFile(test)
      // ResetkmlLayers()
    }

    if (file.length >= 2 && fileCheck.length > 0) {
      resetCheckBox()
      for (let i = 0; i <= 4; i++) {
        kmlLayers(null, 'kml-layer-' + i)
      }

      setPointer('none')
      setLoading(true)

      const check = []
      const res = []
      const fileIndex = (val) => val.name === tag
      file.map((val, i) => (i !== file.findIndex(fileIndex) ? res.push(val) : null))
      const filesDel = res
      filesDel.map((val, i) => check.push({ tag: val.name, id: 'kml-layer-' + i, checked: true }))
      setFile(filesDel)
      setFileCheck(check)
      deleteIDBSingle(id, tag)
      for (let i = 0; i < filesDel.length; i++) {
        let reader = new FileReader()
        reader.readAsText(filesDel[i])
        reader.onload = function () {
          const parsedKML = new DOMParser().parseFromString(reader.result)
          const geojson = converter.kml(parsedKML)

          kmlLayers(geojson, 'kml-layer-' + i)
          if (geojson != undefined && filesDel[i].size === fileMax(filesDel)) {
            setLoading(false)
            setPointer('all')
          }
        }
        reader.onerror = function () {
          console.log(reader.error)
          setErrorModal(true)
          setLoading(false)
        }
      }
    }

    if (file.length === 1 && fileCheck.length > 0) {
      setPointer('all')
      deleteKml()
      acceptedFiles.length = 0
      acceptedFiles.splice(0, acceptedFiles.length)
    }
  }

  const showGeom = (id, tag) => {
    setFileName(tag)
    const item = [...props.layerData]
    const features = item.filter((obj) => obj.id === id)[0].data.features
    setList(features)
    setListWidth({ width: '240px', border: '1px', margin: '5px' })
  }

  const format = (val) => {
    if (val < 1048546) return new Intl.NumberFormat('en').format(val) + ' Bytes'
    if (val >= 1048546) return new Intl.NumberFormat('en').format(Math.floor(val / 1048576)) + ' MB'
  }

  const deleteIDB = () => {
    const request = idb.open('TestDB2', 1)

    request.onsuccess = (event) => {
      event.target.result.transaction('tags', 'readwrite').objectStore('tags').clear()
      event.target.result.transaction('layers', 'readwrite').objectStore('layers').clear()
      event.target.result.transaction('fileList', 'readwrite').objectStore('fileList').clear()
    }
  }

  const deleteIDBSingle = (id, name) => {
    const request = idb.open('TestDB2', 1)
    request.onsuccess = (event) => {
      event.target.result.transaction('tags', 'readwrite').objectStore('tags').delete(id)
      event.target.result.transaction('layers', 'readwrite').objectStore('layers').delete(id)
      event.target.result.transaction('fileList', 'readwrite').objectStore('fileList').delete(name)

      const tags = event.target.result.transaction('tags', 'readwrite').objectStore('tags').getAll()
      tags.onsuccess = () => {
        tags.result.map((obj, i) => {
          const tag = event.target.result.transaction('tags', 'readwrite').objectStore('tags').get(obj.id)
          tag.onsuccess = () => {
            event.target.result.transaction('tags', 'readwrite').objectStore('tags').delete(obj.id)
            const update = tag.result
            update.id = 'kml-layer-' + String(i)
            event.target.result.transaction('tags', 'readwrite').objectStore('tags').put(update)
          }
        })
      }

      const layers = event.target.result.transaction('layers', 'readwrite').objectStore('layers').getAll()
      layers.onsuccess = () => {
        layers.result.map((obj, i) => {
          const tag = event.target.result.transaction('layers', 'readwrite').objectStore('layers').get(obj.id)
          tag.onsuccess = () => {
            event.target.result.transaction('layers', 'readwrite').objectStore('layers').delete(obj.id)
            const update = tag.result
            update.id = 'kml-layer-' + String(i)
            event.target.result.transaction('layers', 'readwrite').objectStore('layers').put(update)
          }
        })
      }
    }
  }

  const getLayers = () => {
    const request = idb.open('TestDB2', 1)

    request.onsuccess = (event) => {
      const tags = event.target.result.transaction('tags', 'readwrite').objectStore('tags').getAll()
      const layers = event.target.result.transaction('layers', 'readwrite').objectStore('layers').getAll()
      const files = event.target.result.transaction('fileList', 'readwrite').objectStore('fileList').getAll()

      files.onsuccess = () => setFile(files.result)
      tags.onsuccess = () => setFileCheck(tags.result)
      layers.onsuccess = () => {
        layers.result.map((obj) => {
          kmlLayersDB(obj.data, obj.id)
        })
        layers.result.length > 0 ? setAddBtn({ events: 'auto', opacity: '1' }) : null
      }
    }
  }

  const getAllData = () => {
    let db = idb.open('TestDB2', 1)

    const data = new Promise((resolve, reject) => {
      db.onsuccess = (event) => {
        const files2 = event.target.result.transaction('fileList', 'readwrite').objectStore('fileList').getAll()
        files2.onsuccess = () => resolve(files2.result)
        files2.oncomplete = () => db.close()
      }
    })

    return data
  }

  const saveIndexDB = (tag, data, id, list) => {
    const db = idb.open('TestDB2', 1)

    db.onsuccess = (event) => {
      const txT = event.target.result.transaction('tags', 'readwrite').objectStore('tags')
      const txL = event.target.result.transaction('layers', 'readwrite').objectStore('layers')
      const txF = event.target.result.transaction('fileList', 'readwrite').objectStore('fileList')

      txT.put(tag)
      txF.put(list)

      const item = props.layerData.find((obj) => obj.id === id)
      item.data = data
      txL.put(item)
    }
  }

  const files = file.map((file) => (
    <div style={{ display: 'flex', fontSize: '15px', height: '35px' }}>
      <InsertDriveFileIcon style={{ color: '#a65e44', alignSelf: 'center', marginRight: '5px' }} />
      <p className="file-tag" key={file.name}>
        {' '}
        {file.name}
      </p>
      <p style={{ marginLeft: '14px', margin: '0px', alignSelf: 'center' }}>
        <b>| {format(file.size)}</b>
      </p>
      <CloseIcon
        style={{ color: '#a65e44', alignSelf: 'center', marginLeft: '5px', cursor: 'pointer' }}
        onClick={() => deleteSingle(1, file.name)}
      />
    </div>
  ))

  const alerts = alertText.map((err) => (
    <div style={{ display: 'flex', marginBottom: '5px' }}>
      <Alert severity="error">
        <b>{err.file}</b> {err.errors}
      </Alert>
    </div>
  ))

  return (
    <Grow in={props.grow} timeout={{ appear: 1000, enter: 1000, exit: 200 }}>
      <div className="kml-mc" style={{ pointerEvents: `${pointer}` }}>
        <div className="ifr-title">
          <p className="ifr-title-txt" style={{ width: '200px' }}>
            KML Viewer
          </p>
          <IconButton
            onClick={() => setSettingsModal(true)}
            size="small"
            style={{ position: 'absolute', top: '0px', right: '0px', borderRadius: '0 0 0 5px' }}
          >
            <SettingsIcon />
          </IconButton>
        </div>

        <div style={{ display: 'flex', margin: `0px ${listWidth.margin} 5px 5px` }}>
          <div
            className="plants-ifr"
            style={{ overflow: 'hidden', height: '300px', margin: `0px 5px 0px 0px`, width: '240px' }}
          >
            {/*<TextField className='file-kml-lbl' style={{marginLeft:'10px',marginTop:'5px'}} id="filled-basic" placeholder="Select a File" disabled={true}  value={filelbl} variant="outlined" size="small"/>*/}

            <Modal
              open={openModal}
              onClose={() => setOpenModal(false)}
              aria-labelledby="simple-modal-title"
              aria-describedby="simple-modal-description"
              style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            >
              <div className="modal-container">
                <IconButton
                  // variant="contained"
                  // className={classes.modalBtn}
                  onClick={() => {
                    setOpenModal(false)
                  }}
                  size="small"
                  style={{ position: 'absolute', top: '0px', right: '0px', borderRadius: '0 0 0 5px' }}
                >
                  <CloseIcon />
                </IconButton>
                <h3 style={{ marginTop: '0px' }}>Select your KML files</h3>

                <div {...getRootProps({ className: 'dropzone' })}>
                  <input {...getInputProps()} />
                  <img
                    src="https://raw.githubusercontent.com/Tycho-Energy/img-quadrant/d9a903764d7954463375e80ec3cc8d5750654725/folder.svg"
                    style={{ height: '70px', marginTop: '0px', width: '70px', display: `${dzDisplay}` }}
                  />
                  <p style={{ fontSize: '14px', display: `${dzDisplay}` }}>
                    Drag and drop your KML files to convert it into a visible layer on the map, or click the select
                    files button.
                  </p>
                  <div>{files}</div>
                </div>
                <div className="modal-alert-container">{alerts}</div>

                <div className="modal-btn-container">
                  <Button
                    variant="contained"
                    className={classes.modalBtn}
                    onClick={open}
                    size="small"
                    component="span"
                    style={{ margin: 'auto', width: '135px' }}
                    startIcon={<FolderIcon />}
                  >
                    Select Files
                  </Button>

                  <Button
                    variant="contained"
                    className={classes.modalBtn}
                    onClick={() => {
                      if (file.length > 0) {
                        upload()
                        setOpenModal(false)
                        setLoading(true)
                      }
                    }}
                    size="small"
                    component="span"
                    style={{ margin: 'auto', width: '135px' }}
                    startIcon={<PublishIcon />}
                  >
                    Upload
                  </Button>

                  <Button
                    variant="contained"
                    className={classes.modalBtn}
                    onClick={() => deleteKml()}
                    size="small"
                    component="span"
                    style={{ margin: 'auto', width: '135px' }}
                    startIcon={<DeleteSweepIcon />}
                  >
                    Delete Files
                  </Button>
                </div>

                <div className="modal-footer">
                  <p className="modal-footer-txt">
                    <b>KML Viewer Tool upload limits:</b> 40 MB per file | Maximum of 5 files.
                  </p>
                </div>
              </div>
            </Modal>

            <Modal
              open={settingsModal}
              onClose={() => setSettingsModal(false)}
              style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            >
              <div className="modal-container" style={{ width: '362px' }}>
                <IconButton
                  // variant="contained"
                  // className={classes.modalBtn}
                  onClick={() => {
                    setSettingsModal(false)
                  }}
                  size="small"
                  style={{ position: 'absolute', top: '0px', right: '0px', borderRadius: '0 0 0 5px' }}
                >
                  <CloseIcon />
                </IconButton>
                <h3 style={{ marginTop: '0px' }}>Change the color of the geometry</h3>

                <div>
                  <div className="settings-title-container">
                    <img className="settings-title-logo" src={polygonLogo} />
                    <p className="settings-title-lbl">Polygon Colors</p>
                  </div>

                  <div className="color-pick-container">
                    <CompactPicker
                      color={colorPolygon}
                      style={{ flexGrow: '2' }}
                      onChangeComplete={(color) => colorChange('polygon', color)}
                    />
                    <div style={{ flexGrow: '1' }}>
                      <div className="color-pick" style={{ background: `${colorPolygon.hex}`, marginTop: '9px' }} />
                      <label className="opaicty-lbl">Opacity</label>
                      <Slider
                        valueLabelFormat={(lbl) => lbl + '%'}
                        className={classes.slider}
                        defaultValue={0}
                        onChangeCommitted={(event, value) => colorChange('polygon', colorPolygon, value)}
                        max={100}
                        min={0}
                        valueLabelDisplay="auto"
                      />
                    </div>
                  </div>
                </div>

                <div>
                  <div className="settings-title-container">
                    <ShowChartIcon className="settings-title-logo" />
                    <p className="settings-title-lbl">Line Colors</p>
                  </div>

                  <div className="color-pick-container">
                    <CompactPicker color={colorLine} onChangeComplete={(color) => colorChange('line', color)} />
                    <div className="color-pick" style={{ background: `${colorLine.hex}` }}></div>
                  </div>
                </div>

                <div>
                  <div className="settings-title-container">
                    <FiberManualRecordIcon className="settings-title-logo" />
                    <p className="settings-title-lbl">Point Colors</p>
                  </div>

                  <div className="color-pick-container">
                    <CompactPicker color={colorPoint} onChangeComplete={(color) => colorChange('point', color)} />
                    <div className="color-pick" style={{ background: `${colorPoint.hex}` }}></div>
                  </div>
                </div>
              </div>
            </Modal>

            <Modal
              open={loading}
              onClose={() => null}
              aria-labelledby="simple-modal-title"
              aria-describedby="simple-modal-description"
              style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            >
              <div className="loading-modal-container">
                <div className="loading-modal-tags">
                  <CircularProgress className={classes.loading} />
                  <h5 className="loading-modal-lbl">Loading</h5>
                </div>
              </div>
            </Modal>

            <Modal
              open={errorModal}
              onClose={() => setErrorModal(false)}
              style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            >
              <div style={{ padding: '15px', background: 'white', borderRadius: '5px', position: 'relative' }}>
                <Alert severity="error">An error has ocurred, please try again</Alert>
              </div>
            </Modal>

            <div style={{ display: 'flex', background: 'rgba(43, 43, 43,0.15)' }}>
              <Button
                className={classes.modalBtn}
                variant="contained"
                component="span"
                size="small"
                disabled={props.grow ? false : true}
                style={{
                  height: '30px',
                  alignSelf: 'center',
                  marginLeft: '5px',
                }}
                startIcon={<CreateNewFolderIcon />}
                // onClick={()=>{load();upload();setPointer('none')}}
                onClick={() => setOpenModal(true)}
              >
                Add Files
              </Button>

              {/*<Tooltip title="Save Layers" placement="top" arrow>
                <IconButton
                  color="default"
                  disabled={props.grow ? false : true}
                  style={{
                    marginLeft: '10px',
                  }}
                  onClick={() => saveLayers()}
                >
                  <SaveIcon  />
                </IconButton>
              </Tooltip>*/}

              <Tooltip title="Delete" placement="top" arrow>
                <IconButton
                  color="default"
                  disabled={props.grow ? false : true}
                  style={{
                    marginLeft: '10px',
                  }}
                  onClick={() => deleteKml()}
                >
                  <DeleteIcon style={{ color: '#bf0000' }} />
                </IconButton>
              </Tooltip>
            </div>

            {fileCheck.map((val) => (
              <div
                className="ifr-switch"
                style={{
                  height: '40px',
                  marginBottom: '0px',
                  borderTop: '1px solid rgba(43, 43, 43, 0.15)',
                  width: '100%',
                  position: 'relative',
                }}
                key={val.id}
              >
                <FormControlLabel
                  style={{ marginLeft: '15px', marginRight: '0px', marginBottom: '-4.5px' }}
                  control={
                    <Checkbox
                      name="kml"
                      size="small"
                      color="default"
                      //   defaultChecked
                      checked={val.checked}
                      icon={<VisibilityOffOutlinedIcon style={{ fontSize: '15px' }} />}
                      checkedIcon={<VisibilityOutlinedIcon style={{ fontSize: '15px', color: '#a65e44' }} />}
                      onChange={(e) => CheckBox(e.target.checked, val.id)}
                      value={val.id}
                    />
                  }
                />
                <LightTooltip title={val.tag} placement="top">
                  <label className="kml-files-lbl">{val.tag}</label>
                </LightTooltip>

                <IconButton
                  // className={classes.kmlDel}
                  component="span"
                  size="small"
                  style={{ height: '25px', width: '25px', position: 'absolute', right: '25px', top: '5px' }}
                  onClick={() => {
                    showGeom(val.id, val.tag)
                  }}
                >
                  <ListAltIcon style={{ fontSize: '20px' }} />
                </IconButton>

                <IconButton
                  // className={classes.kmlDel}
                  component="span"
                  size="small"
                  style={{ height: '25px', width: '25px', position: 'absolute', right: '0px', top: '5px' }}
                  onClick={() => {
                    deleteSingle(val.id, val.tag)
                    // deleteIDBSingle(val.id,val.tag);
                  }}
                >
                  <DeleteIcon style={{ fontSize: '20px' }} />
                </IconButton>
              </div>
            ))}
            <div
              className="ifr-switch"
              style={{
                height: '40px',
                borderTop: '1px solid rgba(43, 43, 43, 0.15)',
                width: '100%',
                position: 'relative',
              }}
            >
              <label
                htmlFor="upload-one"
                style={{ opacity: `${addBtn.opacity}`, pointerEvents: `${addBtn.events}`, transition: '1s opacity' }}
              >
                <input
                  type="file"
                  id="upload-one"
                  name="upload-one"
                  accept=".kml"
                  onChange={uploadSingle}
                  style={{ display: 'none' }}
                />
                <Tooltip title="Add a File" placement="top" arrow>
                  <IconButton
                    // color="default"
                    className={classes.root}
                    // variant="contained"
                    component="span"
                    //size="small"
                    style={{
                      marginLeft: '10px',
                      // marginTop:'10px'
                    }}
                  >
                    <AddIcon />
                  </IconButton>
                </Tooltip>
              </label>
              <div className="mini-alert-container" style={{ opacity: `${alerta}` }}>
                <ReportProblemOutlinedIcon
                  style={{ color: '#ff9800', alignSelf: 'center', marginLeft: '10px', marginRight: '10px' }}
                />
                <p>{alertLbl}</p>
              </div>
            </div>
          </div>

          <div
            className="kml-search-container"
            style={{ width: `${listWidth.width}`, borderWidth: `${listWidth.border}` }}
          >
            <div style={{ background: '#2b2b2b26', borderRadius: '4px 4px 0px 0px', position: 'relative' }}>
              <p className="kml-search-title">{fileName} - Geometry</p>
              <IconButton
                onClick={() => {
                  setListWidth({ width: '0px', border: '0px', margin: '0px' })
                }}
                size="small"
                style={{ position: 'absolute', top: '0px', right: '0px', borderRadius: '0 0 0 5px' }}
              >
                <CloseIcon style={{ height: '16px', width: '16px' }} />
              </IconButton>
            </div>
            <div className="kml-overflow">
              {list.map((obj) => (
                <div
                  style={{
                    borderBottom: '1px solid #2b2b2b26',
                    display: 'flex',
                    height: 'fit-content',
                    fontSize: '12px',
                  }}
                >
                  {obj.geometry.type === 'Point' || obj.geometry.type === 'MultiPoint' ? (
                    <FiberManualRecordIcon className="kml-search-icons" />
                  ) : null}
                  {obj.geometry.type === 'LineString' || obj.geometry.type === 'MultiLineString' ? (
                    <ShowChartIcon className="kml-search-icons" />
                  ) : null}
                  {obj.geometry.type === 'Polygon' ||
                  obj.geometry.type === 'MultiPolygon' ||
                  obj.geometry.type === 'GeometryCollection' ? (
                    <img
                      className="settings-title-logo"
                      style={{ height: '15px', width: '15px', marginLeft: '10px', marginRight: '10px' }}
                      src={polygonLogo}
                    />
                  ) : null}
                  <div style={{ width: '155px' }}>
                    <div style={{ display: 'flex' }}>
                      <p style={{ margin: '0px 5px 0px 0px', alignSelf: 'center', fontWeight: 'bold' }}>Name: </p>
                      <p style={{ margin: '0px 5px 0px 0px', alignSelf: 'center' }}>{obj.properties.name}</p>
                    </div>
                    <div style={{ display: 'flex' }}>
                      <p style={{ margin: '0px 5px 0px 0px', alignSelf: 'center', fontWeight: 'bold' }}>
                        Description:{' '}
                      </p>
                      <p style={{ margin: '0px 5px 0px 0px', alignSelf: 'center' }}>{obj.properties.description}</p>
                    </div>
                  </div>
                  <SearchIcon
                    className="kml-search-btn"
                    onClick={() => props.search(obj.geometry.type, obj.geometry.coordinates)}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Grow>
  )
}

export default KML
